<template>
  <v-container fluid class="fill-height pa-1 u_posAbs">
    <!-- Lišta -->
    <v-app-bar rounded="lg" absolute class="ma-1" dense color="primary">
      <v-alert v-if="NevybLhc" type="info" dense class="text-body-2 mb-0">Není vybrán žádný majetek nebo Lhc.</v-alert>

      <v-toolbar-title v-else>
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-avatar color="info" v-bind="attrs" v-on="on">
              <v-icon dark> mdi-pine-tree </v-icon>
            </v-avatar>
          </template>
          <span>Vybrané Lhc</span>
        </v-tooltip>
        <span class="mx-2 accent--text">{{ VybLhc.LhcKod }}</span>
        <span class="mx-2">{{ VybLhc.LhcNaz }}</span>

        <span v-if="!NevybLhcMaj">
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-avatar color="info" v-bind="attrs" v-on="on">
                <v-icon dark> mdi-account </v-icon>
              </v-avatar>
            </template>
            <span>Vybraný majetek</span>
          </v-tooltip>
          <span class="mx-2 accent--text">{{ VybLhc.MajKod }}</span>
          <span class="mx-2">{{ VybLhc.MajNaz }}</span>
        </span>
      </v-toolbar-title>
    </v-app-bar>

    <!-- Jednotlivá menu -->
    <v-window v-if="!NevybLhc" v-model="VybMenu" class="fill-height fill-width pt-13">
      <!-- Základní menu -->
      <v-window-item value="MenuZakl" class="fill-height">
        <v-card rounded="lg" class="d-flex flex-wrap align-content-start fill-height">
          <!-- schválil -->
          <v-card color="info" max-width="350" min-width="300" rounded height="fit-content" class="ma-1 pa-1">
            <v-card-title class="pa-1 pb-4">{{
              VybLhc.OrgSsl.NAZEV
            }}</v-card-title>
            <v-card-subtitle class="accent--text">Schválil</v-card-subtitle>
            <v-row dense align="center">
              <v-col cols="1">
                <v-icon color="success" class=""> mdi-postage-stamp </v-icon>
              </v-col>
              <v-col cols="11">{{ VybLhc.OrgSsl.ULICE }} {{ VybLhc.OrgSsl.ULICE1 }},
                {{ VybLhc.OrgSsl.POSTA }} {{ VybLhc.OrgSsl.PSC }}</v-col>
            </v-row>
            <v-row dense align="center">
              <v-col cols="1">
                <v-icon color="success"> mdi-phone-classic </v-icon></v-col>
              <v-col cols="11">{{ VybLhc.OrgSsl.TELEFON }}</v-col>
            </v-row>
            <v-row dense align="center">
              <v-col cols="1">
                <v-icon color="success"> mdi-at </v-icon>
              </v-col>
              <v-col cols="11">{{ VybLhc.OrgSsl.EMAIL }}</v-col>
            </v-row>
            <v-row dense align="center">
              <v-col cols="1">
                <v-icon color="success"> mdi-human-greeting </v-icon>
              </v-col>
              <v-col cols="11">{{ VybLhc.OrgSsl.ZASTUPCE }}</v-col>
            </v-row>
          </v-card>

          <!-- Vyhláškové tabulky -->
          <v-btn color="primary2" large class="ma-1 pa-2" @click="VybMenu = 'MenuVyhTab'">
            <v-icon left> mdi-text-box-multiple</v-icon>
            Závěrečné tabulky<br />
            souhrnných údajů</v-btn>

          <!-- Tisk HK -->
          <v-btn color="primary2" large class="ma-1 pa-2" @click="VybMenu = 'MenuTiskHk'" v-if="AppCategory == 'LHPO'">
            <v-icon left> mdi-printer</v-icon>
            Tisk<br />
            hospodářské knihy</v-btn>
        </v-card>
      </v-window-item>

      <!-- Vyhláškové tabulky -->
      <v-window-item value="MenuVyhTab" class="fill-height">
        <div class="d-flex fill-height">
          <v-app-bar rounded="lg" absolute class="" dense color="primary2">
            <v-icon class="mr-3">mdi-text-box-multiple</v-icon>

            <v-toolbar-title>Závěrečné tabulky souhrnných údajů</v-toolbar-title>

            <v-spacer></v-spacer>

            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-btn icon v-bind="attrs" v-on="on" @click="VyhTabVypisLight = !VyhTabVypisLight" class="ml-1">
                  <v-icon v-if="VyhTabVypisLight" color="">mdi-sticker-text</v-icon>
                  <v-icon v-else color="">mdi-sticker-text-outline</v-icon>
                </v-btn>
              </template>
              <span>Inverzní výpis</span>
            </v-tooltip>

            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-card v-bind="attrs" v-on="on" class="mx-1" color="transparent" flat width="200" v-if="true">
                  <v-slider v-model="VyhTabVypisZoom" class="align-center" max="120" min="50" step="1"
                    thumb-color="accent2" hide-details dense>
                    <template v-slot:append>
                      <div v-text="VyhTabVypisZoom + ' %'" class="text-no-wrap text-right mr-2" style="width: 40px"></div>
                    </template>
                  </v-slider>
                </v-card>
              </template>
              <span>Měřítko výpisu</span>
            </v-tooltip>

            <v-btn icon @click="VybMenu = 'MenuZakl'">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-app-bar>

          <div class="d-flex flex-row fill-height fill-width pt-13">
            <v-card rounded="lg" width="100" class="mr-1" style="z-index: 1">
              <!-- Vyhláškové tabulky - menu -->
              <v-tabs v-model="VyhTabVyb" vertical class="">
                <v-tab v-for="item in VyhTabSeznam" :key="item.Id" class="justify-start">
                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <span v-bind="attrs" v-on="on">
                        <v-icon>mdi-text-box</v-icon>
                        <span v-html="item.Id" class="ml-3" />
                      </span>
                    </template>
                    <span v-html="item.Popis" />
                  </v-tooltip>
                </v-tab>
              </v-tabs>
            </v-card>

            <!-- Vyhláškové tabulky - výpis -->
            <div class="fill-width fill-height u_posAbs" style="padding-left: 104px; padding-bottom: 52px">
              <v-card rounded="lg" class="fill-width fill-height pa-2">
                <v-card class="fill-width fill-height pa-2" rounded :light="VyhTabVypisLight" flat>
                  <v-window v-model="VyhTabVyb" class="fill-height fill-width overflow-auto" vertical>
                    <!-- Jednotlivé tabulky -->
                    <v-window-item v-for="item in VyhTabSeznam" :key="item.Id" class="">
                      <div v-if="item.Loading" class="ma-8 text-center">
                        <v-progress-circular indeterminate color="accent"></v-progress-circular>
                      </div>

                      <div v-else class="" :style="{
                        fontSize: (VyhTabVypisZoom / 100) * 16 + 'px',
                      }" v-html="item.Vypis"></div>
                    </v-window-item>
                  </v-window>
                </v-card>
              </v-card>
            </div>
          </div>
        </div>
      </v-window-item>

      <!-- Tisk HK -->
      <v-window-item value="MenuTiskHk" class="fill-height">
        <div class="d-flex fill-height">
          <v-app-bar rounded="lg" absolute class="" dense color="primary2">
            <v-icon class="mr-3">mdi-printer</v-icon>
            <v-toolbar-title>Tisk hospodářské knihy</v-toolbar-title>

            <v-spacer></v-spacer>

            <span class="white--text mx-2">Vybrané jednotky:</span>
            <span class="accent2--text"> {{ TiskHkLhcJprlVyb.length }}</span>

            <v-btn icon x-large color="error" class="ml-10" @mouseover="TiskHkInfoView = true"
              @mouseleave="TiskHkInfoView = false">
              <v-icon>mdi-alert-circle</v-icon>
            </v-btn>

            <v-spacer></v-spacer>

            <v-btn icon @click="VybMenu = 'MenuZakl'">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-app-bar>

          <div class="d-flex flex-row fill-height fill-width pt-13">
            <v-card rounded="lg" width="300" class="mr-1 fill-width fill-height pa-2" style="z-index: 1">
              <v-tooltip left>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn v-bind="attrs" v-on="on" fab small absolute right class="mr-11" color="accent"
                    @click="TiskHkLhcJprlSelectAll()">
                    <v-icon v-if="TiskHkLhcJprlVyb.length == 0">mdi-expand-all</v-icon>
                    <v-icon v-else color="">mdi-collapse-all</v-icon>
                  </v-btn>
                </template>
                <span>Vybrat vše</span>
              </v-tooltip>
              <v-tooltip right>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn v-bind="attrs" v-on="on" fab small absolute right class="" color="accent"
                    @click="TiskHkLhcJprlVybPrintDownloadStart()" :disabled="TiskHkLhcJprlVyb.length == 0">
                    <v-icon color="">mdi-download-multiple</v-icon>
                  </v-btn>
                </template>
                <span>Stažení vybraných položek</span>
              </v-tooltip>

              <v-card class="fill-width fill-height pa-2 overflow-auto" color="transparent" rounded flat>
                <v-treeview dense selectable :items="TiskHkLhcJprl" v-model="TiskHkLhcJprlVyb"></v-treeview>
              </v-card>
            </v-card>

            <div class="fill-width fill-height u_posAbs" style="padding-left: 304px; padding-bottom: 52px">
              <v-card rounded="lg" class="fill-width fill-height pa-2">
                <!--                 <v-tooltip left>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn v-bind="attrs" v-on="on" fab small absolute right color="accent" @click="TiskHk()"
                      :disabled="!TiskHkPrintEnable"><v-icon color="">mdi-printer-check</v-icon></v-btn>
                  </template>
                  <span>Tisk vybraných položek</span>
                </v-tooltip> -->

                <v-speed-dial absolute right direction="bottom" v-if="TiskHkPrintEnable">
                  <template v-slot:activator>
                    <v-tooltip left>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn v-bind="attrs" v-on="on" fab small color="accent"><v-icon
                            color="">mdi-printer-check</v-icon></v-btn>
                      </template>
                      <span>Tisk vybraných položek</span>
                    </v-tooltip>
                  </template>
                  <v-tooltip left>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn v-bind="attrs" v-on="on" fab small color="accent" @click="TiskHk('printVypisLhpo_A4P')">
                        <v-icon>mdi-crop-portrait</v-icon>
                      </v-btn>
                    </template>
                    <span>A4 na výšku</span>
                  </v-tooltip>
                  <v-tooltip left>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn v-bind="attrs" v-on="on" fab small color="accent" @click="TiskHk('printVypisLhpo_A4L')">
                        <v-icon>mdi-crop-landscape</v-icon>
                      </v-btn>
                    </template>
                    <span>A4 na šířku</span>
                  </v-tooltip>

                </v-speed-dial>


                <v-card class="fill-width fill-height pa-2 overflow-auto" rounded light flat>
                  <TiskHkSestava id="PrintAreaTiskHk" :TiskHkLhcJprlVybPrint="TiskHkLhcJprlVybPrint" class=""
                    v-if="TiskHkPrintEnable"></TiskHkSestava>
                </v-card>
              </v-card>
            </div>
          </div>
        </div>

        <!-- Upozornění stahování -->
        <v-snackbar v-model="TiskHkInfoView" timeout="-1">
          <v-alert class="" type="error" dense icon="mdi-alert-circle-outline">Maximální počet jednotek, pro které lze
            najednou vygenerovat
            hospodářskou knihu, záleží na konfiguraci vašeho počítače a
            aktuálním vytížení.<br />
            V případě nedostatku paměti omezte výběr.
          </v-alert>
        </v-snackbar>

        <!-- Ukazatel stahování -->
        <v-overlay :value="TiskHkDownloadWorking">
          <v-progress-circular :rotate="90" :size="100" :width="15" :value="TiskHkDownloadWorkingProgress" color="accent">
            {{ TiskHkDownloadWorkingProgress }}
          </v-progress-circular>
        </v-overlay>
      </v-window-item>
    </v-window>

    <!-- Upozornění -->
    <v-dialog v-model="Alert_view" max-width="400">
      <v-alert class="pa-4 ma-0" type="error" dense icon="mdi-alert-circle-outline">{{ Alert_text }}
      </v-alert>
    </v-dialog>
  </v-container>
</template>

<script>
import ServiceLhpo from "../services/ServiceLhpo";
//import PrintPokus from "../assets/temporary/LhcPrint.json";

import print from "./common/print";

export default {
  components: {
    TiskHkSestava: () => import("./LhcInfo/TiskHkSestava.vue"),
  },

  props: {
    // Jméno komponenty
    CompName: { type: String },
    // Kategorie aplikace
    AppCategory: { type: String },
    // Adresa webové služby
    AppServiceurl: { type: Object },
    // Seznam  komponent
    CompList: { type: Array },
  },

  data() {
    return {
      // Upozornění
      Alert_view: false,
      // Upozornění - text
      Alert_text: "",
      // Vybrané zobrazobané menu MenuZakl, MenuVyhTab, MenuTiskHk
      VybMenu: "MenuZakl",
      // Vyhláškové tabulky - seznam, zdrojový předpis
      VyhTabSeznamZdroj: [
        { Id: "0", Popis: "Základní údaje", Loading: true, Vypis: null },
        {
          Id: "1",
          Popis: "Základní údaje podle kategorií lesa",
          Loading: true,
          Vypis: null,
        },
        {
          Id: "2",
          Popis: "Základní údaje podle kategorií a věkových stupňů",
          Loading: true,
          Vypis: null,
        },
        {
          Id: "3ab",
          Popis: "Porostní plocha podle dřevin a věkových stupňů",
          Loading: true,
          Vypis: null,
        },
        {
          Id: "3c",
          Popis: "Základní údaje podle dřevin",
          Loading: true,
          Vypis: null,
        },
        {
          Id: "4",
          Popis: "Základní údaje dle kategorií lesa a obmýtí",
          Loading: true,
          Vypis: null,
        },
        {
          Id: "5a",
          Popis:
            "Základní údaje podle hospodářských způsobů, kategorií a tvarů lesa<br/>Hospodářský způsob holosečný, násečný a podrostní",
          Loading: true,
          Vypis: null,
        },
        {
          Id: "5b",
          Popis:
            "Základní údaje podle hospodářských způsobů, kategorií a tvarů lesa<br/>Hospodářský způsob výběrný",
          Loading: true,
          Vypis: null,
        },
        {
          Id: "6",
          Popis: "Výčet zaujatých katastrálních území",
          Loading: true,
          Vypis: null,
        },
      ],
      // Vyhláškové tabulky - seznam
      VyhTabSeznam: null,
      // Vyhláškové tabulky - vybraná tabulka
      VyhTabVyb: null,
      // Měřítko výpisu
      VyhTabVypisZoom: 100,
      // Měřítko výpisu
      VyhTabVypisLight: false,

      // Tisk HK - celkový seznam Jprl
      TiskHkLhcJprl: [],
      // Tisk HK - vybrané Jprl
      TiskHkLhcJprlVyb: [],
      // Tisk HK - vybrané jprl k tisku
      TiskHkLhcJprlVybPrint: {},

      // Tisk HK - Celkový počet výpisů/porostů ke stažení
      TiskHkDownloadCount: 0,
      // Tisk HK - Počet již stažených výpisů
      TiskHkDownloaded: 0,
      // Tisk HK - Počet již stažených výpisů a vpořádku
      TiskHkDownloadedReady: 0,
      // Tisk HK - probíhá stahování
      TiskHkDownloadWorking: false,
      // Tisk HK - povolení výstupu na tiskárnu
      TiskHkPrintEnable: false,
      // Tisk HK - zobrazení upozornění
      TiskHkInfoView: false,
    };
  },

  computed: {
    // Změna vybrané komponenty podle jména
    VybComp: {
      get() {
        return this.$store.getters.GET_sVybComp;
      },
      set(newValue) {
        this.$store.commit("SET_sVybComp", {
          CompName: newValue,
          SlotName: this.CompList.find((item) => item.name == newValue).slot,
        });
      },
    },

    // Vybrané Lhc
    VybLhc: function () {
      return this.$store.getters.GET_sVybLhc;
    },

    // Zda je neybrané Lhc
    NevybLhc: function () {
      if (this.VybLhc.LhcKod == null) {
        return true;
      } else {
        return false;
      }
    },
    // Zda je neybrán majetek
    NevybLhcMaj: function () {
      if (this.VybLhc.MajKod == null) {
        return true;
      } else {
        return false;
      }
    },

    // ukazatel stahování
    TiskHkDownloadWorkingProgress: function () {
      if (this.TiskHkDownloadCount != 0) {
        return (
          Math.round((this.TiskHkDownloaded / this.TiskHkDownloadCount) * 100) +
          " %"
        );
      } else {
        return 0;
      }
    },
  },

  watch: {
    // Změna Lhc
    VybLhc: function (value) {
      this.ZmenaLhc(value);
    },
    // Změna zobrazené funkce
    VybMenu: function (value, oldValue) {
      switch (oldValue) {
        case "MenuZakl":
          break;
        case "MenuVyhTab":
          break;

        case "MenuTiskHk":
          break;

        default:
        // code block
      }

      switch (value) {
        case "MenuZakl":
          break;
        case "MenuVyhTab":
          break;

        case "MenuTiskHk":
          if (this.TiskHkLhcJprl.length == 0) {
            this.NactiLhcSeznamJprl();
          }

          break;

        default:
        // code block
      }
    },

    // Změna VyhTab
    VyhTabVyb: function (value) {
      //   console.log('změna');
      // console.log(value);
      if (value != null) {
        this.ZmenaVyhTabVyb(value);
      }
    },
  },

  methods: {
    // Změna Lhc
    ZmenaLhc: function (value) {
      if (value.Jid !== null && typeof value.Jid !== "undefined") {
        // Vyhláškové tabulky - Klonování ze zdroje - čistý seznam
        this.VyhTabSeznam = JSON.parse(JSON.stringify(this.VyhTabSeznamZdroj));
        // Tisk Hk - Vše vynulovat
        this.TiskHkLhcJprl = [];
        this.TiskHkLhcJprlVyb = [];
        this.TiskHkLhcJprlVybPrint = {};
        this.TiskHkDownloadCount = 0;
        this.TiskHkDownloaded = 0;
        this.TiskHkDownloadedReady = 0;
        this.TiskHkPrintEnable = false;

        // načíst tabulku, když je zobrazená
        if (this.VybMenu == "MenuVyhTab" && this.VyhTabVyb != null) {
          this.ZmenaVyhTabVyb(this.VyhTabVyb);
        } else {
          // vynulovat ukazatel
          this.VyhTabVyb = null;
        }

        // načíst seznam Jprl, když je zobrazen tisk Hk
        if (this.VybMenu == "MenuTiskHk") {
          this.NactiLhcSeznamJprl();
        }
      }
    },

    // Změna tabulky
    ZmenaVyhTabVyb: function (value) {
      var sVyhTabVyb = this.VyhTabSeznam[value];

      if (sVyhTabVyb.Loading && sVyhTabVyb.Vypis == null) {
        // načíst tabulku, když je potřeba
        //console.log(sVyhTabVyb)
        this.NactiLhcTab(sVyhTabVyb.Id);
      }
    },

    // WS - Seznam Jprl
    NactiLhcTab: function (Tab) {
      ServiceLhpo.LhcTab(this.VybLhc.Jid, this.VybLhc.MajKod, Tab)
        .then((response) => {
          if (response.data.Dokonceno) {
            // Jestli nedošlo ke změně Lhc
            if (
              this.VybLhc.Jid == response.data.Zadani.Jid &&
              this.VybLhc.MajKod == response.data.Zadani.MajKod
            ) {
              var vVyhTabVyb = this.VyhTabSeznam.filter(
                (item) => item.Id == response.data.Zadani.Tab
              )[0];

              vVyhTabVyb.Loading = false;
              vVyhTabVyb.Vypis = response.data.Tabulka;
            }
          } else {
            this.Alert_text = response.data.Chyba;
            this.Alert_view = true;
          }
        })
        .catch((error) => {
          console.log(error);
        })
        .then(function () {
          // always executed
        });
    },

    // WS - Seznam Jprl
    NactiLhcSeznamJprl: function () {
      this.TiskHkLhcJprl = [];
      this.TiskHkLhcJprlVyb = [];
      this.TiskHkLhcJprlVybPrint = {};
      this.TiskHkDownloadCount = 0;
      this.TiskHkDownloaded = 0;
      this.TiskHkDownloadedReady = 0;
      this.TiskHkPrintEnable = false;

      ServiceLhpo.LhcSeznamJprl(this.VybLhc.Jid, this.VybLhc.MajKod)
        .then((response) => {
          if (response.data.Dokonceno) {
            this.TiskHkLhcJprlCreate(response.data.SeznamJprl);
          } else {
            this.Alert_text = response.data.Chyba;
            this.Alert_view = true;
          }
        })
        .catch((error) => {
          console.log(error);
          this.vOddIds = [];
        })
        .then(function () {
          // always executed
        });
    },

    // přeformátování TiskHkLhcJprl
    TiskHkLhcJprlCreate: function (value) {
      var transformed;

      if (value != null) {
        if (value.length > 1) {
          // s IddId
          transformed = value.map(function (item) {
            var vIdOddId = item.ODD_ID;
            return {
              id: vIdOddId,
              name: item.ODD_ID,
              children: item.sOdds.map(function (item) {
                var vIdOdd = vIdOddId + "-" + item.ODD;
                return {
                  id: vIdOdd,
                  name: item.ODD,
                  children: item.sDils.map(function (item) {
                    var vIdDil = vIdOdd + "-" + item.DIL;
                    return {
                      id: vIdDil,
                      name: item.DIL,
                      children: item.sPors.map(function (item) {
                        var vIdPor = vIdDil + "-" + item.POR;
                        return {
                          id: vIdPor,
                          name: item.POR,
                          children: item.sJprls.map(function (item) {
                            return {
                              id: item.U_JID,
                              name: item.PSK_BZL_JP_OP,
                              typJprl: item.TYP_JPRL,
                            };
                          }),
                        };
                      }),
                    };
                  }),
                };
              }),
            };
          });
        } else {
          // bez IddId
          transformed = value[0].sOdds.map(function (item) {
            var vIdOdd = item.ODD;
            return {
              id: vIdOdd,
              name: item.ODD,
              children: item.sDils.map(function (item) {
                var vIdDil = vIdOdd + "-" + item.DIL;
                return {
                  id: vIdDil,
                  name: item.DIL,
                  children: item.sPors.map(function (item) {
                    var vIdPor = vIdDil + "-" + item.POR;
                    return {
                      id: vIdPor,
                      name: item.POR,
                      children: item.sJprls.map(function (item) {
                        return {
                          id: item.U_JID,
                          name: item.PSK_BZL_JP_OP,
                          typJprl: item.TYP_JPRL,
                        };
                      }),
                    };
                  }),
                };
              }),
            };
          });
        }

        this.TiskHkLhcJprl = transformed;
      }
    },

    // Vše vybrat
    TiskHkLhcJprlSelectAll: function () {
      // Když je něco vybráno - vše odvybrat
      if (this.TiskHkLhcJprlVyb.length > 0) {
        this.TiskHkLhcJprlVyb = [];
      } else {
        var _TiskHkLhcJprlVyb = this.TiskHkLhcJprlVyb;
        this.TiskHkLhcJprl.forEach(function (item) {
          _TiskHkLhcJprlVyb.push(item.id);
        });
      }
    },

    // Vytvoření seznamu pro tisk
    TiskHkLhcJprlVybPrintCreate: function () {
      var _TiskHkLhcJprlVybPrint = {};

      this.TiskHkLhcJprlVyb.forEach(function (item) {
        var PorKey = item.substr(0, 20);

        if (!_TiskHkLhcJprlVybPrint[PorKey]) {
          _TiskHkLhcJprlVybPrint[PorKey] = { Vypis: null, SeznamJprl: {} };
        }
        _TiskHkLhcJprlVybPrint[PorKey].SeznamJprl[item] = null;
      });

      this.TiskHkLhcJprlVybPrint = _TiskHkLhcJprlVybPrint;
    },

    // stažení dat pro tisk - začátek
    TiskHkLhcJprlVybPrintDownloadStart: function () {
      if (this.TiskHkLhcJprlVyb.length > 0) {
        this.TiskHkDownloadWorking = true;

        this.TiskHkLhcJprlVybPrintCreate();

        // Dotazy seskupené po porostech
        this.TiskHkDownloadCount = Object.keys(
          this.TiskHkLhcJprlVybPrint
        ).length;
        this.TiskHkDownloaded = 0;
        this.TiskHkDownloadedReady = 0;
        this.TiskHkPrintEnable = false;

        for (let item in this.TiskHkLhcJprlVybPrint) {
          //var JidLhc = item.substr(0, 10);
          var JidJprl = [];

          for (let item2 in this.TiskHkLhcJprlVybPrint[item].SeznamJprl) {
            JidJprl.push(item2.substr(11, 40));
          }

          this.NactiLhcJprlVypis(this.VybLhc.Jid, JidJprl.toString());
        }
      }
    },

    // stažení dat pro tisk - konec
    TiskHkLhcJprlVybPrintDownloadEnd: function () {
      this.TiskHkDownloadWorking = false;

      if (this.TiskHkDownloadCount != this.TiskHkDownloadedReady) {
        // něco se nestáhlo
        this.Alert_text =
          "Nepodařilo se načíst všechna požadovaní data. Zkuste akci zopakovat";
        this.Alert_view = true;
      } else {
        // vše se stáhlo
        this.TiskHkPrintEnable = true;
      }

      this.TiskHkDownloadCount = 0;
      this.TiskHkDownloaded = 0;
      this.TiskHkDownloadedReady = 0;
    },

    // WS - výpisy
    NactiLhcJprlVypis: function (JidLhc, JidJprl) {
      ServiceLhpo.LhcJprlVypis(JidLhc, JidJprl)
        .then((response) => {
          if (response.data.Dokonceno) {
            var _TiskHkLhcJprlVybPrint = this.TiskHkLhcJprlVybPrint;

            // Výpis porostu
            response.data.SeznamPor.forEach(function (item) {
              if (_TiskHkLhcJprlVybPrint[item.Jid]) {
                _TiskHkLhcJprlVybPrint[item.Jid].Vypis = item.Vypis;

                // Výpis jprl
                item.SeznamJprl.forEach(function (item2) {
                  if (
                    _TiskHkLhcJprlVybPrint[item.Jid].SeznamJprl[item2.Jid] !==
                    "undefined"
                  ) {
                    _TiskHkLhcJprlVybPrint[item.Jid].SeznamJprl[item2.Jid] =
                      item2.Vypis;
                  }
                });
              }
            });

            this.TiskHkDownloadedReady += 1;
          } else {
            this.Alert_text = response.data.Chyba;
            this.Alert_view = true;
          }
        })
        .catch((error) => {
          console.log(error);
          this.vOddIds = [];
        })
        .then(() => {
          // always executed
          this.TiskHkDownloaded += 1;

          if (this.TiskHkDownloaded == this.TiskHkDownloadCount) {
            this.TiskHkLhcJprlVybPrintDownloadEnd();
          }
        });
    },

    TiskHk: function (value) {
      print.PrintObj(
        document.getElementById("PrintAreaTiskHk"),
        !this.NevybLhcMaj
          ? this.VybLhc.LhcKod +
          " " +
          this.VybLhc.LhcNaz +
          " (" +
          this.VybLhc.MajKod +
          " " +
          this.VybLhc.MajNaz +
          ")"
          : this.VybLhc.LhcKod + " " + this.VybLhc.LhcNaz,
        [value, "printVypisLhpo"]
      );
    },
  },

  mounted() {
    // Nastavení služby
    ServiceLhpo.Init(this.AppServiceurl.ServiceLhpo);
    this.ZmenaLhc(this.VybLhc);

    //this.TiskHkLhcJprlVybPrint = PrintPokus;
  },
};
</script>

<style >
/* Převzaté styly, pouze pro VTTab (hned na začátku) doplněny tři vlastnosti  */

.VTTab {
  font-size: 1em;

  /* Nové začátek */
  line-height: normal;
  padding: auto;
  box-sizing: content-box;
  /* Nové konec */
}

.VTcontent-0 {
  width: 55em;
  height: auto;
  display: block;
  float: left;
  font-family: Arial, Helvetica, sans-serif;
  border: 0.09em solid;
  padding-bottom: 10em;
}

.VTcontent-1 {
  width: 60em;
  height: 39em;
  display: block;
  float: left;
  font-family: Arial, Helvetica, sans-serif;
  border: 0.09em solid;
}

.VTcontent-2 {
  width: 60em;
  height: 67.5em;
  display: block;
  float: left;
  font-family: Arial, Helvetica, sans-serif;
  border: 0.09em solid;
}

.VTcontent-3 {
  width: 60em;
  height: auto;
  display: block;
  float: left;
  font-family: Arial, Helvetica, sans-serif;
  border: 0.09em solid;
  padding-bottom: 3.5em;
}

.VTcontent-4 {
  width: 40em;
  height: auto;
  display: block;
  float: left;
  font-family: Arial, Helvetica, sans-serif;
  border: 0.09em solid;
  padding-bottom: 3.5em;
}

.VTcontent-5A {
  width: 40em;
  height: auto;
  display: block;
  float: left;
  font-family: Arial, Helvetica, sans-serif;
  border: 0.09em solid;
  padding-bottom: 4em;
}

.VTcontent-5B {
  width: 40em;
  height: auto;
  display: block;
  float: left;
  font-family: Arial, Helvetica, sans-serif;
  border: 0.09em solid;
  padding-bottom: 4em;
}

.VTcontent-6 {
  width: 40em;
  height: auto;
  display: block;
  float: left;
  font-family: Arial, Helvetica, sans-serif;
  border: 0.09em solid;
  padding-bottom: 3.5em;
}

.VTcontent-7 {
  width: 60em;
  height: 62em;
  display: block;
  float: left;
  font-family: Arial, Helvetica, sans-serif;
  border: 0.09em solid;
}

.VTcontent-15 {
  width: 65em;
  height: auto;
  display: block;
  float: left;
  font-family: Arial, Helvetica, sans-serif;
  border: 0.09em solid;
  padding-bottom: 3.5em;
}

.VTheader {
  position: relative;
  display: block;
  float: left;
  width: 60em;
  height: 2em;
  border-bottom: 0.09em solid;
}

.VTleft-header-s {
  position: relative;
  display: block;
  float: left;
  width: 3em;
  height: 2em;
  font-weight: bold;
  text-align: center;
  border-bottom: 0.09em solid;
  border-right: 0.09em solid;
}

.VTleft-header-l {
  position: relative;
  display: block;
  float: left;
  width: 6em;
  height: 2em;
  font-weight: bold;
  text-align: center;
  border-bottom: 0.09em solid;
  border-right: 0.09em solid;
}

.VTright-header-s-1 {
  position: relative;
  display: block;
  float: left;
  width: 36.91em;
  height: 2em;
  border-bottom: 0.09em solid;
}

.VTright-header-s {
  position: relative;
  display: block;
  float: left;
  width: 51.91em;
  height: 2em;
  border-bottom: 0.09em solid;
}

.VTright-header-l {
  position: relative;
  display: block;
  float: left;
  width: 56.91em;
  height: 2em;
  border-bottom: 0.09em solid;
}

.VTright-header-l-1 {
  position: relative;
  display: block;
  float: left;
  width: 53.91em;
  height: 2em;
  border-bottom: 0.09em solid;
}

.VTright-header-l-2 {
  position: relative;
  display: block;
  float: left;
  width: 61.91em;
  height: 2em;
  border-bottom: 0.09em solid;
}

.VTheader-name-1 {
  position: relative;
  display: block;
  float: left;
  top: 0.4em;
  left: 10em;
  font-weight: bold;
  width: 36em;
}

.VTheader-name-2 {
  position: relative;
  display: block;
  float: left;
  top: 0.4em;
  left: 3em;
  font-weight: bold;
  width: 20em;
}

.VTheader-date {
  position: relative;
  display: block;
  float: left;
  top: 0.4em;
  left: 17em;
}

.VTheader-date-1 {
  position: relative;
  display: block;
  float: left;
  top: 0.4em;
  left: 12em;
}

.VTheader-date-2 {
  position: relative;
  display: block;
  float: left;
  top: 0.4em;
  left: 9em;
}

.VTheader-date-3 {
  position: relative;
  display: block;
  float: left;
  top: 0.4em;
  left: 31em;
}

.VTtitle1-0 {
  position: relative;
  top: 0.5em;
  display: block;
  float: left;
  width: 53.3em;
  text-align: left;
  font-weight: bold;
  padding-left: 1em;
  padding-right: 0.5em;
}

.VTtitle1 {
  position: relative;
  top: 0.5em;
  display: block;
  float: left;
  width: 35em;
  text-align: left;
  font-weight: bold;
  padding-left: 1em;
  padding-right: 0.5em;
}

.VTtitle1-1 {
  position: relative;
  top: 0.8em;
  display: block;
  float: left;
  width: 33em;
  text-align: left;
  font-weight: bold;
  font-size: 1.15em;
  padding-left: 0.8em;
  padding-right: 0.5em;
}

.VTtitle1-1-l {
  position: relative;
  top: 0.8em;
  display: block;
  float: left;
  width: 50em;
  text-align: left;
  font-weight: bold;
  font-size: 1.15em;
  padding-left: 0.8em;
  padding-right: 0.5em;
}

.VTtitle1-2 {
  position: relative;
  top: 2em;
  left: 1.2em;
  display: block;
  float: left;
  width: 34.5em;
  text-align: left;
  font-weight: bold;
  font-size: 0.8em;
}

.VTtitle2 {
  position: relative;
  top: 2em;
  display: block;
  width: 22em;
  text-align: right;
  float: left;
  font-size: 0.8em;
}

.VTresult2 {
  position: relative;
  top: 2em;
  left: 0.2em;
  display: block;
  width: 29.7em;
  text-align: left;
  font-weight: bold;
  float: left;
  font-size: 0.8em;
}

.VTtitleLHPO {
  position: relative;
  top: 2.3em;
  display: block;
  width: 42.2em;
  float: left;
  text-align: center;
  font-weight: bold;
  font-size: 1.3em;
}

.VTtitle3-1 {
  position: relative;
  top: 5em;
  display: block;
  width: 9.5em;
  text-align: left;
  padding: 0.2em;
  padding-left: 1.8em;
  float: left;
  font-size: 0.8em;
}

.VTtitle3-2 {
  position: relative;
  top: 6.3em;
  display: block;
  width: 9.5em;
  text-align: left;
  padding: 0.2em;
  padding-left: 1.8em;
  float: left;
  font-size: 0.8em;
}

.VTtitle3-3 {
  position: relative;
  top: 10em;
  display: block;
  width: 8em;
  text-align: right;
  padding: 0.2em;
  padding-left: 2.5em;
  float: left;
  font-size: 0.8em;
}

.VTresult3-1 {
  position: relative;
  top: 5em;
  display: block;
  width: 56em;
  text-align: left;
  font-weight: bold;
  padding-left: 1em;
  padding: 0.2em;
  float: left;
  font-size: 0.8em;
}

.VTresult3-2 {
  position: relative;
  top: 6.3em;
  display: block;
  width: 56em;
  min-height: 1.15em;
  text-align: left;
  font-weight: bold;
  padding-left: 1em;
  padding: 0.2em;
  float: left;
  font-size: 0.8em;
}

.VTresult3-3 {
  position: relative;
  top: 10em;
  left: 0.5em;
  display: block;
  width: 12em;
  text-align: left;
  font-weight: bold;
  padding: 0.2em;
  float: left;
  font-size: 0.8em;
}

.VTborder-tab0-1 {
  position: relative;
  top: 6.5em;
  left: 6.1em;
  display: block;
  width: 24em;
  height: 2.9em;
  float: left;
}

.VTborder-tab0-2 {
  position: relative;
  top: 8em;
  left: 0.6em;
  display: block;
  width: 54em;
  height: 8.3em;
  float: left;
}

.VTborder-tab1-1 {
  position: relative;
  top: 1.7em;
  left: 1em;
  display: block;
  width: 58em;
  height: 31em;
  float: left;
}

.VTborder-tab2-1 {
  position: relative;
  top: 1.7em;
  left: 1em;
  display: block;
  width: 58.5em;
  height: 15em;
  float: left;
}

.VTborder-tab3-1 {
  position: relative;
  top: 1.7em;
  left: 1em;
  display: block;
  width: 58.5em;
  height: 30em;
  float: left;
}

.VTborder-tab3-2 {
  position: relative;
  top: 1.7em;
  left: 1.5em;
  display: block;
  width: auto;
  height: 30em;
  float: left;
}

.VTborder-tab4 {
  position: relative;
  top: 1.7em;
  left: 1.5em;
  display: block;
  width: 32.5em;
  height: 24em;
  float: left;
}

.VTborder-tab5-a {
  position: relative;
  top: 2.5em;
  left: 1.5em;
  display: block;
  width: auto;
  height: auto;
  float: left;
}

.VTborder-tab5-b {
  position: relative;
  top: 2.5em;
  left: 1.5em;
  display: block;
  width: auto;
  height: auto;
  float: left;
}

.VTborder-tab6 {
  position: relative;
  top: 1.7em;
  left: 1.5em;
  display: block;
  width: auto;
  min-height: 10em;
  max-height: 450em;
  float: left;
}

.VTborder-tab7 {
  position: relative;
  top: 4em;
  left: 1.5em;
  display: block;
  width: 56em;
  height: auto;
  float: left;
}

.VTborder-tab11 {
  position: relative;
  top: 1.7em;
  left: 1.5em;
  display: block;
  width: auto;
  height: auto;
  float: left;
}

.VTTab0-A-table {
  width: 30em;
  font-family: Arial, Helvetica, sans-serif;
  border-collapse: collapse;
  font-size: 0.8em;
}

.VTth0-A-set {
  text-align: center;
  padding: 0.2em;
  height: 1.7em;
  border: 0.09em solid;
}

.VTtd0-A-left {
  border: 0.09em solid;
  text-align: right;
  padding: 0.2em;
  width: 50%;
}

.VTtd0-A-right {
  border: 0.09em solid;
  text-align: left;
  padding: 0.2em;
  width: 50%;
}

.VTTab0-B-table {
  font-family: Arial, Helvetica, sans-serif;
  border-collapse: collapse;

  text-align: center;
  font-size: 0.7em;
}

.VTTab1-table {
  font-family: Arial, Helvetica, sans-serif;
  text-align: center;
  border-collapse: collapse;
  font-size: 0.7em;
}

.VTTab2-table {
  font-family: Arial, Helvetica, sans-serif;
  text-align: center;
  border-collapse: collapse;
  font-size: 0.7em;
}

.VTTab3-table {
  font-family: Arial, Helvetica, sans-serif;
  text-align: left;
  border-collapse: collapse;
  font-size: 0.7em;
}

.VTTab4-table {
  font-family: Arial, Helvetica, sans-serif;
  text-align: center;
  border-collapse: collapse;
  font-size: 0.7em;
}

.VTborder-full {
  border: 0.09em solid;
}

.VTborder-no-bottom {
  border-left: 0.09em solid;
  border-right: 0.09em solid;
  border-top: 0.09em solid;
  border-bottom: none;
}

.VTborder-no-top {
  border-left: 0.09em solid;
  border-right: 0.09em solid;
  border-bottom: 0.09em solid;
  border-top: none;
}

.VTborder-no-left {
  border-left: none;
  border-right: 0.09em solid;
  border-bottom: 0.09em solid;
  border-top: 0.09em solid;
}

.VTborder-bold-top {
  border-top: 0.2em solid;
}

.VTborder-bold-bottom {
  border-bottom: 0.2em solid;
}

.VTborder-bold-left {
  border-left: 0.2em solid;
}

.VTborder-bold-right {
  border-right: 0.2em solid;
}

.VTheight0-1 {
  height: 2.2em;
}

.VTheight0-2 {
  height: 4.4em;
}

.VTheight0-3 {
  height: 6.6em;
}

.VTheight1-0 {
  height: 1.4em;
}

.VTheight1-0-1 {
  height: 1.6em;
}

.VTheight1-1 {
  height: 1.82em;
}

.VTheight1-1-1 {
  height: 2.7em;
}

.VTheight1-2 {
  height: 3.2em;
}

.VTheight1-3 {
  height: 4.8em;
}

.VTheight1-5 {
  height: 7.8em;
}

.VTwidth-1_5 {
  max-width: 1.5em;
}

.VTwidth-2 {
  max-width: 2em;
  min-width: 2em;
}

.VTwidth-3 {
  width: 3em;
}

.VTwidth-3_9 {
  width: 3.82em;
}

.VTwidth-4 {
  width: 4em;
}

.VTwidth-5 {
  width: 5em;
}

.VTwidth-6 {
  max-width: 6em;
  min-width: 6em;
}

.VTwidth-7 {
  width: 7.5em;
}

.VTwidth-8 {
  width: 8.1em;
}

.VTwidth-9 {
  width: 9em;
}

.VTwidth-10 {
  width: 10em;
}

.VTwidth-12 {
  width: 12em;
}

.VTwidth-14 {
  width: 14em;
}

.VTwidth-16 {
  width: 16.2em;
}

.VTwidth-18 {
  width: 18em;
  table-layout: fixed;
}

.VTwidth-20 {
  width: 20em;
}

.VTwidth-24 {
  width: 24em;
}

.VTwidth-25 {
  width: 25em;
}

.VTwidth-27 {
  width: 27em;
}

.VTwidth-50 {
  width: 50em;
}

.VTvertical {
  position: relative;
  writing-mode: vertical-rl;
  transform: rotate(180deg);
  white-space: nowrap;
}

.VTbold {
  font-weight: bold;
}

.VTleft {
  text-align: left;
  padding-left: 0.2em;
}

.VTright {
  text-align: right;
  padding-right: 0.2em;
}

.VTcenter {
  text-align: center;
}

.VTPadding-full {
  padding: 0.3em;
}

.VTsize0-6 {
  font-size: 0.85em;
}

.VTsize1-2 {
  font-size: 1.2em;
  padding-top: 0.1em;
}

.VTsize1-6 {
  font-size: 1.6em;
  padding-top: 0.1em;
}

@import "./common/VypisLhpo.css";
</style>